import { useEffect } from 'react';

import { css } from '@compiled/react';
import { styled } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { UfoCustomTimingWrapper } from '@/components/signup/utils/ufo-custom-timing-wrapper';
import { ufoEventRedirectToProduct } from '@/components/signup/utils/ufo-events';
import { UfoCustomTimingKey } from '@/components/signup/utils/ufo.types';
import MainContainer from '@/templates/ondemand/signup/confirmation/confirmation-page/src/components/main-container/main-container';
import { ExperimentView } from '@/utils/experiment/experiment-view';
import { experiments } from '@/utils/experiment/manifest';

import { useAnalyticsClient } from '../../../../../../../../analytics/wac-analytics/analytics-client';
import { DwellTimeWrapper } from '../../components/dwell-time-wrapper/dwell-time-wrapper';
import { MessageContainerProps } from '../../components/styles';
import ProgressBar from '../../sections/progress-bar';
import { LegacyConfirmationPageLayout } from '../view-switch';

import { ServiceCollectionProvisioningAnimation } from './components/service-collection-provisioning-animation';
import { ServiceCollectionProvisioningScreenLofi } from './service-collection-provisioning-screen-lofi';

const MessageContainer = css(MessageContainerProps);
export const StyledRelativePosition = styled.div({
	position: 'relative',
});

const ServiceCollectionProvisioningScreen = () => {
	const analyticsClient = useAnalyticsClient();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		analyticsClient &&
			createAnalyticsEvent({
				eventName: 'serviceCollectionProvisioningPageViewed',
				eventComponent: 'serviceCollectionProvisioningPage',
				event: 'viewed',
			}).fire('signup');
	}, [analyticsClient, createAnalyticsEvent]);

	return (
		<UfoCustomTimingWrapper
			ufoEvent={ufoEventRedirectToProduct}
			ufoCustomTimingKey={UfoCustomTimingKey.SERVICE_COLLECTION_PROVISIONING_VIEW_DWELL_TIME}
		>
			<DwellTimeWrapper
				eventData={{
					eventName: 'serviceCollectionProvisioningPageDwelled',
					eventComponent: 'serviceCollectionProvisioningPage',
					event: 'dwelled',
					actionSubject: 'serviceCollectionProvisioningPage',
					source: 'bxp-web-platform-wac-confirmation-page',
				}}
				initialPollInterval={2000}
				idleTimeout={120000}
				nextPollIntervalCallback={(x) => x + 2000}
			>
				<StyledRelativePosition>
					<MainContainer>
						<ServiceCollectionProvisioningAnimation />
						<ProgressBar />

						<p css={MessageContainer} data-testid="service-collection-provisioning-message">
							<FormattedMessage
								id="WacConfirmationPage.serviceCollectionProvisioning"
								defaultMessage="Thank you for signing up! We're creating your site and setting up your Service Collection apps."
							/>
						</p>
					</MainContainer>
				</StyledRelativePosition>
			</DwellTimeWrapper>
		</UfoCustomTimingWrapper>
	);
};

export default () => (
	<ExperimentView
		experiment={experiments.servCoLofiBackground}
		// @ts-ignore
		render={(value) =>
			value ? (
				<ServiceCollectionProvisioningScreenLofi />
			) : (
				<LegacyConfirmationPageLayout>
					<ServiceCollectionProvisioningScreen />
				</LegacyConfirmationPageLayout>
			)
		}
	/>
);
